document.addEventListener('DOMContentLoaded', function() {
  const gridSwitchers = document.querySelectorAll('.grid__switcher');
  const productLayout = document.querySelector('.collection__grid');

  gridSwitchers.forEach(button => {
    button.addEventListener('click', () => {
      gridSwitchers.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      if (button.classList.contains('grid__two')) {
        productLayout.setAttribute('data-cols', '2');
      } else if (button.classList.contains('grid__one')) {
        productLayout.setAttribute('data-cols', '1');
      }
    });
  });
});